import React, { Component } from "react";

import Home from "./../../components/home";

export default class HomeContainer extends React.Component {
  render = () => <Home />;
}
